module.exports = __webpack_public_path__ + "img/calculated-values.8aee48cd.gif";